module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><a href="/#person/'+
((__t=( child.id ))==null?'':__t)+
'" target="_blank">'+
((__t=( child.name ))==null?'':__t)+
'</a></td>\n<td>'+
((__t=( formatDate(startTime) ))==null?'':__t)+
'</td>\n<td>'+
((__t=( formatDate(endTime) ))==null?'':__t)+
'</td>\n<td>\n    ';
 _.each(contacts, function(contact){ 
__p+='\n    <span class="label ';
 if (contact.preferred) { 
__p+=' label-success ';
 } else { 
__p+=' label-primary ';
 } 
__p+='" style="font-size: 14px;">\n        '+
((__t=( contact.type ))==null?'':__t)+
' - '+
((__t=( contact.data ))==null?'':__t)+
'\n    </span>&nbsp;\n    ';
 }) 
__p+='\n</td>\n';
 if (canEdit) { 
__p+='\n<td><span class="glyphicon glyphicon-edit clickable org-person-edit" title="Edit"/></td>\n<td><span class="glyphicon glyphicon-remove clickable org-person-remove" title="Remove"/></td>\n';
 } 
__p+='\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/organizations/organization-persons-item-view.html
// module id = 282
// module chunks = 0